import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'tcat-mobile-view-port-pane',
  templateUrl: './mobile-view-port-pane.component.html',
  styleUrls: ['./mobile-view-port-pane.component.scss']
})
export class MobileViewPortPaneComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
